import { Actions, UseProgressState } from './types';

const initialState = {
  pages: {},
};

export const defaultState = (): UseProgressState => initialState;

export const reducers = (state: UseProgressState, action: Actions): UseProgressState => {
  switch (action.type) {
    case 'SET_TOTAL':
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.page]: {
            ...state.pages[action.payload.page],
            total: action.payload.total,
          },
        },
      };
    case 'SET_FOUND':
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.page]: {
            ...state.pages[action.payload.page],
            found: (state.pages[action.payload.page]?.found ?? 0) + (action.payload.found ?? 1),
          },
        },
      };
  }
};
